<template>
  <div class="tools-bar-wrapper">
    <!--    v-show="!showSearch"-->
    <van-space :size="10">
      <van-button
        class="tab-btn"
        :class="{ active: item.key === activeHomeChildMenuTab }"
        type="default"
        size="small"
        block
        :text="item.label"
        @click="onTabChange(item)"
        v-for="item in tabs"
        :key="item.key"
      />
    </van-space>
    <div class="search-wrapper">
      <van-search
        ref="searchRef"
        v-model="searchValue"
        shape="round"
        placeholder="搜索"
        @clear="onClear"
        @focus="showSearch = true"
        @blur="onBlur"
      >
        <template #left-icon>
          <svg-icon class="search-icon" icon-name="search" :height="46" />
        </template>
        <!--        <template #action v-if="showSearch">-->
        <!--          <van-button class="search-btn" type="primary" round @click="onSearch">搜索</van-button>-->
        <!--        </template>-->
      </van-search>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { storeToRefs, useGameStore } from '@star/stores';
import { useRoute, useRouter } from 'vue-router';
import { GameChildTypesEnum, GameMainTypesEnum } from '@star/constants';
import { includes, pickBy, toNumber } from 'lodash-es';
import type { SearchInstance } from 'vant';
import { emitter, EventEnum } from '@star/utils';
import { useDebounceFn } from '@vueuse/core';

const route = useRoute();
const router = useRouter();
const gameStore = useGameStore();
const { activeHomeMainMenuTab, activeHomeSubMenuTab, activeHomeChildMenuTab } = storeToRefs(gameStore);

const searchValue = ref<string>();
const showSearch = ref<boolean>(false);
const searchRef = ref<SearchInstance>();

const tabs = computed(() => {
  console.log(activeHomeSubMenuTab.value, 'activeHomeSubMenuTab');
  return [
    {
      label: '全部',
      key: GameChildTypesEnum.ALL,
    },
    {
      label: '热门',
      key: GameChildTypesEnum.HOT,
    },
    {
      label: '最近',
      key: GameChildTypesEnum.RECENT,
    },
    {
      label: '收藏',
      key: GameChildTypesEnum.COLLECT,
    },
  ].filter(item => {
    if (
      includes(
        [GameMainTypesEnum.HOT_ELECTRONIC, GameMainTypesEnum.HOT_FISHING, GameMainTypesEnum.HOT_CHESS],
        toNumber(activeHomeSubMenuTab.value)
      )
    ) {
      return item.key !== GameChildTypesEnum.HOT;
    }
    return !0;
  });
});

const onTabChange = (item: any) => {
  console.log(item.key, '--------onChildChange');
  gameStore.setActiveHomeChildMenuTab(item.key);
  router.push({
    name: 'home',
    params: {
      mainType: activeHomeMainMenuTab.value ?? '',
      subType: activeHomeSubMenuTab.value ?? '',
    },
    query: pickBy({ ...route.query, childType: item.key }, val => !!val),
  });
};

const onSearch = (val?: string) => {
  console.log('search', searchValue.value, val);
  emitter.emit(EventEnum.HOME_SEARCH_GAME, searchValue.value);
};

const onClear = () => {
  searchRef.value?.blur?.();
};

const onBlur = () => {
  // console.log('onBlur', searchValue.value);
  if (!searchValue.value) {
    showSearch.value = false;
    emitter.emit(EventEnum.HOME_SEARCH_GAME, searchValue.value);
  }
};

const debouncedFn = useDebounceFn(
  () => {
    onSearch(searchValue.value);
  },
  1000,
  { maxWait: 3000 }
);

watch(
  () => searchValue.value,
  value => {
    debouncedFn();
  }
);

emitter.on(EventEnum.HOME_SEARCH_GAME_RESET, val => {
  searchValue.value = undefined;
  showSearch.value = false;
  emitter.emit(EventEnum.HOME_SEARCH_GAME, searchValue.value);
});

onMounted(() => {
  if (!activeHomeChildMenuTab.value) {
    gameStore.setActiveHomeChildMenuTab(GameChildTypesEnum.ALL);
  }
});

onUnmounted(async () => {
  emitter.off(EventEnum.HOME_SEARCH_GAME_RESET);
});
</script>

<style lang="less" scoped>
.tools-bar-wrapper {
  display: flex;
  align-items: center;
  margin-top: 3px;

  .van-space {
    flex: none;
    margin-right: 30px;
  }

  .search-wrapper {
    flex: 1;
    height: 100px;

    :deep(.van-search) {
      border: 3px solid #dedfe5;
      border-radius: 45px;
      padding: 0;
      height: 100%;
      background: transparent;
      transition: 0.3s;

      &__content {
        background: transparent;
        padding-left: 30px;
      }

      &__field {
        height: 100%;
        line-height: 1;
        display: flex !important;
        align-items: center !important;
        flex-wrap: nowrap !important; /* 禁止 flex 换行 */
        white-space: nowrap !important; /* 禁止文本换行 */
      }

      &__action {
        line-height: 1;
        padding: 0;
      }
    }

    .search-btn {
      height: 70px;
      line-height: 70px;
      border: none;
      font-size: 39px;
      font-weight: 400;
      margin-right: 12px;
    }

    .search-icon {
      margin-right: 10px;
      color: #bbbfc8;
    }
  }

  .tab-btn {
    height: 96px;
    line-height: 96px;
    padding: 0 15px;
    background: #fff;
    border: none;
    color: #afafaf;
    font-size: 45px;
    font-weight: 400;

    &.active {
      color: var(--theme-primary-color);
      font-weight: 600;
    }
  }
}
</style>
